import { render } from "./ToolbarAvatar.vue?vue&type=template&id=57dfb37a&scoped=true"
import script from "./ToolbarAvatar.vue?vue&type=script&lang=js"
export * from "./ToolbarAvatar.vue?vue&type=script&lang=js"

import "./ToolbarAvatar.vue?vue&type=style&index=0&id=57dfb37a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dfb37a"]])

export default __exports__